module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/unit/unit.html
// module id = 623
// module chunks = 0